module.exports = __webpack_public_path__ + "static/media/noImage25px.6807632d.svg";